import React from "react";
import Logo from "../Logo";

interface DefaultHeaderProps {
  className?: string;
}

const DefaultHeader: React.FC<DefaultHeaderProps> = (props) => {
  return (
    <header className={`flex justify-center py-4 md:py-8 ${props.className}`}>
      <div>
        <Logo />
      </div>
    </header>
  );
};

export default DefaultHeader;
